import React, { createContext, useContext, useState } from 'react';

const NotificationContext = createContext();

export const useNotifications = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotifications must be used within a NotificationProvider');
    }
    return context;
};

export const NotificationProvider = ({ children }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [message, setMessage] = useState('');
    const [type, setType] = useState('success');

    const showNotification = (message, type = 'success') => {
        setMessage(message);
        setType(type);
        setIsVisible(true);

        setTimeout(() => {
            setIsVisible(false);
        }, 3000);
    };

    const iconMap = {
        success: (
            <svg className="w-6 h-6 text-green-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7"></path>
            </svg>
        ),
        warning: (
            <svg className="w-6 h-6 text-yellow-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01M12 2v2m0 4v12"></path>
            </svg>
        ),
        info: (
            <svg className="w-8 h-8 text-blue-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01M12 2v2m0 4v12" />
            </svg>
        ),
    };

    return (
        <NotificationContext.Provider value={{ showNotification }}>
            {children}
            {isVisible && (
                <div className={`fixed top-0 left-1/2 transform -translate-x-1/2 z-50 bg-white border border-gray-300 shadow-lg rounded-lg p-4 flex items-center gap-3 transition-all duration-300 mt-[50px]`}>
                    {iconMap[type]}
                    <span className="text-gray-800">{message}</span>
                </div>
            )}
        </NotificationContext.Provider>
    );
};